<template>
  <router-view v-slot="{ Component, route }">
    <transition name="slide-left">
      <keep-alive>
        <component
          :is="Component"
          v-if="isKeepAlive"
          :key="route.meta.key"
        />
      </keep-alive>
    </transition>

    <transition name="slide-left">
      <component
        :is="Component"
        v-if="!isKeepAlive"
        :key="route.meta.key"
      />
    </transition>
  </router-view>
</template>

<script>
import { computed } from 'vue';
import { useRoute } from 'vue-router';

export default {
  name: 'App',
  components: {
  },
  setup () {
    const route = useRoute();
    const isKeepAlive = computed(() => route.meta.keepAlive || false);

    return {
      isKeepAlive
    };
  }
};
</script>

<style lang="scss">
html, body {
  touch-action: manipulation;
}

body {
  margin: 0px;
  padding: 0px;

  a,
  input,
  textarea,
  button,
  select,
  a {
    -webkit-tap-highlight-color: transparent;
  }
}

#app {
  font-family: Noto Sans TC, Roboto, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  position: relative;
}

// page transition
.slide-left-enter-active {
  animation: slideLeft 0.3s;
}

@keyframes slideLeft {
  from {
    transform: translate3d(100%, 0, 0);
    visibility: visible;
  }

  to {
    transform: translate3d(0, 0, 0);
  }
}
</style>
